import React from "react";

const Header = () => {
  return (
    <header className="h-20 text-white text-center bg-gray-600 flex items-center px-4 shadow-gray-800 shadow-sm font-bold text-lg">
      <div className="text-lg md:text-2xl">Dashboard</div>
    </header>
  );
};

export default Header;
